import { PreRegistrationManagerPanel } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => PreRegistrationManagerPanel,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.PreRegistrationManagerPanel) =>
    kontentAiDataMapping.pre_registration_manager_panel(entry),
  depthParameter: 5,
};
